/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ExcelImportFileDropper from 'shared/ui/components/form-components/pickers/ExcelImportFileDropper.vue';
import AppscriptExportModal from 'shared/ui/components/modals/AppscriptExportModal.vue';

const __vue_script__ = {
    name: 'SessionImport',

    components: {
        ExcelImportFileDropper
    },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        const options = this.params.currentController?.routeOptions || {};

        return {
            showExport: options.sessionExportEnabled,
            date: this.$utils.time.dateToFormat(this.$utils.time.now(), this.$const.DEFAULT_DATETIME_FORMAT),
            errors: []
        };
    },

    methods: {
        onImportStart() {
            this.errors = [];
            this.$notify({
                group: 'flashes',
                text: this.t('import_started').toString(),
                type: 'success'
            });
        },

        onImportEnd() {
            this.$notify({
                group: 'flashes',
                text: this.t('import_succeeded').toString(),
                type: 'success'
            });
        },

        onImportFailure(results) {
            if (results) {
                this.errors = results.reduce((p, r, idx) => {
                    if (r.error) {
                        p.push(`#${idx + 1}: ${r.message}`);
                    }
                    return p;
                }, []);
            }
            this.$notify({
                group: 'flashes',
                text: this.t('import_failed').toString(),
                type: 'error'
            });
        },

        exportSessionRegistrations() {
            this.$modal.show(AppscriptExportModal, {
                title: this.t('export_modal.title'),
                jobScript: 'agenda/export-all-registrations',
                jobOptions: {
                    name: 'Export All Session Registrations',
                    fileName: `Session-Registrations-${this.params.event._id}-${this.date}.xlsx`
                },
                event: this.params.event
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        },

        t(key) {
            return this.$i18n.t(`registration.sessions_configuration.session_import_page.${key}`).toString();
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "session-import-export" }, [
    _c(
      "div",
      { staticClass: "session-import" },
      [
        _c("h5", [_vm._v(_vm._s(_vm.t("import_title")))]),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.t("import_subtitle"))),
        ]),
        _c("excel-import-file-dropper", {
          attrs: {
            "event-id": _vm.params.event._id,
            "import-type": "session-registrations",
          },
          on: {
            "import-start": _vm.onImportStart,
            "import-start-failure": _vm.onImportFailure,
            "import-end": _vm.onImportEnd,
            "import-failure": _vm.onImportFailure,
          },
        }),
        _vm.errors.length
          ? _c("div", { staticClass: "help error" }, [
              _c("h6", [_vm._v(_vm._s(_vm.t("import_failed")))]),
              _c(
                "ul",
                _vm._l(_vm.errors, function (error) {
                  return _c("li", [_vm._v(_vm._s(error))])
                }),
                0
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
    _vm.showExport
      ? _c("div", { staticClass: "session-export" }, [
          _c("h5", [_vm._v(_vm._s(_vm.t("export_title")))]),
          _c("div", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.t("export_subtitle"))),
          ]),
          _c("div", { staticClass: "action" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-export",
                on: { click: _vm.exportSessionRegistrations },
              },
              [_vm._v(_vm._s(_vm.t("export_action")))]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/session-registration/SessionImport.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__